module.exports = __webpack_public_path__ + "img/logo.4307c295.png";